import { useLocation, useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { campaignThemeStore } from "../../stores";
import { useEffect } from "react";
import PageBox from "../../layout/PageBox";
import { afd_application_completed_background, mi } from "../../imgs";
import { Button } from "antd";
import { MyColor } from "../../config/myStyle";
import { useTranslation } from "react-i18next";

const CampaignCreateSuccess = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const campaignThemeId = location.state?.campaignThemeId as string | undefined;

  useEffect(() => {
    if (!campaignThemeId) {
      navigate("/campaign/create/select-type");
      return;
    }
    campaignThemeStore.getCampaignTheme({ id: campaignThemeId });
  }, [campaignThemeId, navigate]);

  return (
    <PageBox spinning={false}>
      <div
        className="flex flex-col items-center px-[18px] py-[20px]"
        style={{
          // 成功页封面图固定替换为指定素材，不再跟随主题背景切换。
          backgroundImage: `url(${afd_application_completed_background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="mb-[18px] text-center text-[24px] font-[600]"
          style={{ color: MyColor.blue }}
        >
          {t("campaign_create_success.title")}
        </div>

        <div className="w-full rounded-[24px] bg-[rgba(255,255,255,0.95)] px-[18px] py-[22px] shadow-[0_10px_24px_rgba(0,0,0,0.08)]">
          <div
            className="text-[14px] leading-[1.7]"
            style={{ color: "rgba(0,0,0,0.78)" }}
            dangerouslySetInnerHTML={{ __html: t("campaign_create_success.success_text") }}
          />

          <div className="mt-[24px] flex justify-center">
            <Button
              type="primary"
              htmlType="button"
              style={{
                width: 140,
                borderRadius: 22,
                background: MyColor.sub,
                height: 44,
                fontSize: 18,
                color: "white",
                fontWeight: 500,
              }}
              onClick={() => navigate("/")}
            >
              {t("campaign_create_success.home")}
            </Button>
          </div>
        </div>

        <img className="mt-[24px] h-[180px]" src={mi} alt="" />
      </div>
    </PageBox>
  );
});

export default CampaignCreateSuccess;
